(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-patent-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('patent-split-video')) {
    customElements.define('patent-split-video', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.dialog = this.querySelector('dialog');
        this.video = this.querySelector('video');
        if (!this.dialog || !this.video) return;
        this.trigger = this.querySelector('[data-video-open]');
        this.toggle = this.querySelector('[data-video-toggle]');
        this.player = this.querySelector('.ps__modal-player');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.trigger.addEventListener('click', () => this.open(), options);
        this.querySelector('[data-video-close]').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        }, options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open) this.finishClose();
        }, options);
        this.dialog.addEventListener('transitionend', (event) => {
          if (this.closing && event.target === this.dialog && event.propertyName === 'opacity') this.finishClose();
        }, options);
        this.toggle.addEventListener('click', () => {
          if (this.video.paused || this.video.ended) this.play();
          else this.video.pause();
        }, options);
        ['play', 'pause', 'ended'].forEach((type) => {
          this.video.addEventListener(type, () => {
            if (type === 'play' && (!this.dialog.open || this.closing)) {
              this.video.pause();
              return;
            }
            const playing = !this.video.paused && !this.video.ended;
            this.player.classList.toggle('is-playing', playing);
            this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
            if (this.video.ended) this.video.currentTime = 0;
          }, options);
        });
      }

      open() {
        if (this.dialog.open || this.closing) return;
        this.dialog.showModal();
        this.lockScroll();
        // Establish the initial frame so entrance and exit use the same transition.
        void this.dialog.offsetWidth;
        this.dialog.classList.add('is-open');
        this.play();
      }

      play() {
        this.video.muted = false;
        this.video.volume = 1;
        this.video.play().catch(() => {
          // Keep the play button available if the browser rejects playback.
          if (this.dialog.open && !this.closing) {
            this.player.classList.remove('is-playing');
            this.toggle.setAttribute('aria-label', this.toggle.dataset.playLabel);
          }
        });
      }

      close() {
        if (!this.dialog.open || this.closing) return;
        this.closing = true;
        this.video.pause();
        this.dialog.classList.remove('is-open');
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.finishClose();
        } else {
          // Fallback covers interrupted transitions and background tabs.
          this.closeTimer = window.setTimeout(() => this.finishClose(), 400);
        }
      }

      finishClose() {
        window.clearTimeout(this.closeTimer);
        this.video.pause();
        this.dialog.classList.remove('is-open');
        if (this.dialog.open) this.dialog.close();
        this.unlockScroll();
        this.closing = false;
      }

      lockScroll() {
        const root = document.documentElement;
        const body = document.body;
        this.scrollPosition = { x: window.scrollX, y: window.scrollY };
        const gap = window.innerWidth - root.clientWidth;
        const padding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
        this.savedStyles = [];
        const set = (element, property, value) => {
          this.savedStyles.push([element, property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
          element.style.setProperty(property, value);
        };
        set(root, 'overflow', 'hidden');
        set(root, 'scroll-behavior', 'auto');
        set(body, 'position', 'fixed');
        set(body, 'top', `-${this.scrollPosition.y}px`);
        set(body, 'left', `-${this.scrollPosition.x}px`);
        set(body, 'width', '100%');
        set(body, 'overflow', 'hidden');
        set(body, 'box-sizing', 'border-box');
        if (gap > 0) set(body, 'padding-right', `${padding + gap}px`);
      }

      unlockScroll() {
        if (!this.savedStyles) return;
        const restore = ([element, property, value, priority]) => {
          if (value) element.style.setProperty(property, value, priority);
          else element.style.removeProperty(property);
        };
        const scrollBehavior = this.savedStyles.find(([, property]) => property === 'scroll-behavior');
        this.savedStyles.filter(([, property]) => property !== 'scroll-behavior').forEach(restore);
        window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
        restore(scrollBehavior);
        this.savedStyles = null;
      }

      disconnectedCallback() {
        if (!this.events) return;
        this.events.abort();
        this.events = null;
        this.finishClose();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-routine-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-routine-steps')) {
    customElements.define('c-routine-steps', class extends HTMLElement {
      connectedCallback() {
        this.steps = [...this.querySelectorAll('[data-routine-step]')];
        this.slides = [...this.querySelectorAll('[data-routine-slide]')];
        this.buttons = [...this.querySelectorAll('[data-routine-go]')];
        if (!this.steps.length) return;
        this.stage = this.querySelector('.c-routine-steps__stage-wrap');
        this.body = this.querySelector('.c-routine-steps__body');
        this.viewport = this.querySelector('.c-routine-steps__viewport');
        this.textViewport = this.querySelector('.c-routine-steps__text-viewport');
        this.stepList = this.querySelector('.c-routine-steps__steps');
        this.activeIndex = -1;
        this.editorIndex = null;
        this.desktop = window.matchMedia('(min-width: 978px)');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updateFromScroll();
          });
        };
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, options);
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-routine-go]');
          if (!button || !this.contains(button)) return;
          this.scrollToStep(Number(button.dataset.routineGo));
        }, options);
        this.addEventListener('focusin', (event) => {
          if (this.desktop.matches) return;
          const target = event.target;
          if (!target.closest('[data-routine-step]')) return;
          requestAnimationFrame(() => {
            if (options.signal.aborted || this.desktop.matches || document.activeElement !== target) return;
            this.updateFromScroll();
            const rect = target.getBoundingClientRect();
            const area = this.textViewport.getBoundingClientRect();
            if (rect.top < area.top || rect.bottom > area.bottom) {
              window.scrollBy({
                top: rect.top < area.top ? rect.top - area.top - 4 : rect.bottom - area.bottom + 4,
                behavior: 'instant'
              });
            }
          });
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.steps.findIndex((step) => step.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorIndex = index;
          this.select(index);
          this.scrollToStep(index);
        }, options);
        document.addEventListener('shopify:block:deselect', () => {
          this.editorIndex = null;
          this.schedule();
        }, options);
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this);
        this.observer.observe(this.viewport);
        this.steps.forEach((step) => this.observer.observe(step));
        this.setAttribute('data-enhanced', '');
        this.select(0);
        this.schedule();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
      }

      viewingArea() {
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--sl-c-routine-top')) || 0;
        return { top: offset + 12, bottom: window.innerHeight - 12, stickyTop: offset };
      }

      updateFromScroll() {
        const area = this.viewingArea();
        const center = (area.top + area.bottom) / 2;
        if (!this.desktop.matches) {
          const viewportHeight = this.viewport.getBoundingClientRect().height;
          const textHeight = this.textViewport.getBoundingClientRect().height;
          this.style.setProperty('--sl-c-routine-text-height', `${textHeight}px`);
          const distance = Math.max(0, this.stepList.getBoundingClientRect().height - textHeight);
          this.style.setProperty('--sl-c-routine-scroll-height', `${viewportHeight + distance}px`);
          const progress = Math.min(distance, Math.max(0, area.stickyTop - this.body.getBoundingClientRect().top));
          this.style.setProperty('--sl-c-routine-text-offset', `${-progress}px`);
          if (this.editorIndex != null) return;
          const boundary = this.textViewport.getBoundingClientRect().top;
          let index = 0;
          this.steps.forEach((step, i) => {
            if (step.getBoundingClientRect().top <= boundary + 1) index = i;
          });
          this.select(index);
          return;
        }
        if (this.editorIndex != null) return;
        let candidate = -1;
        let distance = Infinity;
        this.steps.forEach((step, index) => {
          const rect = step.querySelector('.c-routine-steps__step-content').getBoundingClientRect();
          const fullyVisible = rect.top >= area.top - 1 && rect.bottom <= area.bottom + 1;
          // Long merchant content cannot fit on short screens: use its midpoint instead.
          const oversized = rect.height > area.bottom - area.top;
          const midpoint = rect.top + rect.height / 2;
          const crossesCenter = oversized && rect.top <= center && rect.bottom >= center;
          if ((fullyVisible || crossesCenter) && Math.abs(midpoint - center) < distance) {
            candidate = index;
            distance = Math.abs(midpoint - center);
          }
        });
        if (candidate >= 0) this.select(candidate);
      }

      select(index) {
        if (index === this.activeIndex) return;
        this.activeIndex = index;
        this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          if (i === index) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.buttons.forEach((button, i) => {
          if (i === index) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
      }

      scrollToStep(index) {
        const content = this.steps[index]?.querySelector('.c-routine-steps__step-content');
        if (!content) return;
        const area = this.viewingArea();
        if (!this.desktop.matches) {
          this.updateFromScroll();
          const offset = this.steps[index].getBoundingClientRect().top - this.stepList.getBoundingClientRect().top;
          const top = window.scrollY + this.body.getBoundingClientRect().top - area.stickyTop + offset;
          window.scrollTo({ top, behavior: this.motion.matches ? 'instant' : 'smooth' });
          return;
        }
        const rect = content.getBoundingClientRect();
        const top = window.scrollY + rect.top + rect.height / 2 - (area.top + area.bottom) / 2;
        window.scrollTo({ top, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-science-in-every-step"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-science-results')) {
    customElements.define('c-science-results', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motion.matches || !('IntersectionObserver' in window)) return;

        this.items = [];
        this.active = new Map();
        this.querySelectorAll('.c-science-in-every-step__comparison, .c-science-in-every-step__stats').forEach((group) => {
          group.querySelectorAll('.c-science-in-every-step__comparison-item, .c-science-in-every-step__stat').forEach((element, index) => {
            const value = element.querySelector('.c-science-in-every-step__bar-value, .c-science-in-every-step__stat-value');
            const original = value ? value.textContent : '';
            const match = original.match(/^([^\d]*)(\d+(?:,\d{3})*(?:\.\d+)?)([^\d]*)$/);
            const item = { element, value, original, delay: index * 140 };

            if (match) {
              const decimals = (match[2].split('.')[1] || '').length;
              item.target = Number(match[2].replace(/,/g, ''));
              item.format = new Intl.NumberFormat('en-US', {
                useGrouping: match[2].includes(','),
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
              });
              item.prefix = match[1];
              item.suffix = match[3];
              const accessible = document.createElement('span');
              accessible.className = 'c-science-in-every-step__counter-accessible';
              accessible.textContent = original;
              item.counter = document.createElement('span');
              item.counter.setAttribute('aria-hidden', 'true');
              item.counter.textContent = `${item.prefix}${item.format.format(0)}${item.suffix}`;
              value.replaceChildren(accessible, item.counter);
            }

            element.style.setProperty('--sl-c-science-in-every-step-progress', '0');
            this.items.push(item);
          });
        });

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const item = this.items.find((candidate) => candidate.element === entry.target);
            this.active.set(item, performance.now() + item.delay);
            this.observer.unobserve(entry.target);
          });
          if (this.active.size && !this.animationFrame) {
            this.animationFrame = requestAnimationFrame((time) => this.animate(time));
          }
        }, { threshold: 0.25 });
        this.items.forEach((item) => this.observer.observe(item.element));

        this.onMotionChange = () => {
          if (this.motion.matches) this.finish();
        };
        this.motion.addEventListener('change', this.onMotionChange);
      }

      animate(time) {
        this.animationFrame = null;
        this.active.forEach((start, item) => {
          const progress = Math.min(1, Math.max(0, (time - start) / 1800));
          const eased = 1 - Math.pow(1 - progress, 4);
          item.element.style.setProperty('--sl-c-science-in-every-step-progress', String(eased));
          if (item.counter) {
            const factor = 10 ** item.format.resolvedOptions().maximumFractionDigits;
            const current = Math.floor(item.target * eased * factor) / factor;
            item.counter.textContent = `${item.prefix}${item.format.format(current)}${item.suffix}`;
          }
          if (progress === 1) {
            this.restore(item);
            this.active.delete(item);
          }
        });
        if (this.active.size) {
          this.animationFrame = requestAnimationFrame((nextTime) => this.animate(nextTime));
        }
      }

      restore(item) {
        item.element.style.removeProperty('--sl-c-science-in-every-step-progress');
        if (item.counter) item.value.textContent = item.original;
      }

      finish() {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        if (this.observer) this.observer.disconnect();
        if (this.active) this.active.clear();
        if (this.items) this.items.forEach((item) => this.restore(item));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.finish();
        if (this.onMotionChange) this.motion.removeEventListener('change', this.onMotionChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
